import request from '@/utils/request'

/**
 * 获取套餐列表
 * @param {Object} params - 查询参数
 * @param {Number} params.page - 页码
 * @param {Number} params.page_size - 每页条数
 * @param {String} params.product_code - 所属商品编码（必填）
 * @param {Number} params.status - 状态筛选（可选，-1=全部，0=下架，1=上架）
 */
export function getPackageList(params) {
  return request({
    url: '/fuyou/iccid/recharge/admin/packages/list',
    method: 'post',
    data: {
      page: params.page || 1,
      page_size: params.page_size || 20,
      product_code: params.product_code,  // 必填
      status: params.status !== undefined ? params.status : -1  // 默认-1显示全部
    }
  })
}

/**
 * 创建套餐
 * @param {Object} data - 套餐数据
 * @param {String} data.product_code - 所属商品编码（必填）
 * @param {String} data.package_code - 套餐编码（必填，唯一）
 * @param {String} data.package_name - 套餐名称（必填）
 * @param {Number} data.price - 套餐价格（必填）
 * @param {Number} data.duration - 有效期天数（必填）
 * @param {String} data.data_amount - 流量额度（必填）
 * @param {String} data.description - 套餐描述（可选）
 * @param {Number} data.status - 状态（可选，0=下架，1=上架，默认1）
 * @param {String} data.merchant_code - 商户号（可选，来自数据字典 FYPAY 的 dict_value）
 * @param {String} data.merchant_name - 商户名称（可选，来自数据字典 FYPAY 的 dict_label）
 */
export function createPackage(data) {
  return request({
    url: '/fuyou/iccid/recharge/admin/packages/create',
    method: 'post',
    data: {
      product_code: data.product_code,
      package_code: data.package_code,
      package_name: data.package_name,
      price: data.price,
      duration: data.duration,
      data_amount: data.data_amount,
      description: data.description || '',
      status: data.status !== undefined ? data.status : 1,
      merchant_code: data.merchant_code || '',
      merchant_name: data.merchant_name || ''
    }
  })
}

/**
 * 更新套餐
 * @param {Object} data - 套餐数据
 * @param {Number} data.id - 套餐ID（必填）
 * @param {String} data.product_code - 所属商品编码（必填）
 * @param {String} data.package_code - 套餐编码（必填）
 * @param {String} data.package_name - 套餐名称（必填）
 * @param {Number} data.price - 套餐价格（必填）
 * @param {Number} data.duration - 有效期天数（必填）
 * @param {String} data.data_amount - 流量额度（必填）
 * @param {String} data.description - 套餐描述（可选）
 * @param {Number} data.default_commission_type - 默认分佣类型（必填，1=百分比，2=固定金额）
 * @param {Number} data.default_commission_value - 默认分佣值（必填）
 * @param {Number} data.sort_order - 排序（必填）
 * @param {Number} data.status - 状态（必填，0=禁用，1=启用）
 * @param {String} data.merchant_code - 商户号（可选，来自数据字典 FYPAY 的 dict_value）
 * @param {String} data.merchant_name - 商户名称（可选，来自数据字典 FYPAY 的 dict_label）
 */
export function updatePackage(data) {

  const requestData = {
    id: data.id,
    product_code: data.product_code,
    package_code: data.package_code,
    package_name: data.package_name,
    price: data.price,
    duration: data.duration,
    data_amount: data.data_amount,
    description: data.description || '',
    default_commission_type: data.default_commission_type,
    default_commission_value: data.default_commission_value,
    sort_order: data.sort_order,
    status: data.status,
    merchant_code: data.merchant_code,
    merchant_name: data.merchant_name
  }

  return request({
    url: '/fuyou/iccid/recharge/admin/packages/update',
    method: 'post',
    data: requestData
  })
}

/**
 * 更新套餐状态
 * @param {Object} data - 状态数据
 * @param {Number} data.id - 套餐ID（必填）
 * @param {String} data.package_code - 套餐编码（必填）
 * @param {Number} data.status - 状态（必填，0=下架，1=上架）
 */
export function updatePackageStatus(data) {
  return request({
    url: '/fuyou/iccid/recharge/admin/packages/update-status',
    method: 'post',
    data: {
      id: data.id,
      package_code: data.package_code,
      status: data.status
    }
  })
}
